import { gql, useQuery } from '@apollo/client'
import { Box, Dialog, IconButton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Carousel from 'packages/ui/Carousel'

import { SMOOTH_ICON_SX } from '../components/styles'

export const OPERATION_PICTURES = gql`
  query FindEquipmentPictures($uuid: ID!) {
    pictures: findEquipmentPictures(uuid: $uuid) {
      url
      width
      height
    }
  }
`

type PicturesProps = {
  open: boolean
  onClose: () => void
  uuid?: string
  initialIndex?: number
}

const Pictures = ({ open, onClose, uuid, initialIndex = 0 }: PicturesProps) => {
  const { t } = useTranslation()

  const { data, loading } = useQuery(OPERATION_PICTURES, {
    variables: { uuid },
    skip: !open || !uuid
  })

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: '24px',
          width: 'min(880px, calc(100vw - 32px))',
          maxWidth: '880px',
          overflow: 'hidden',
          backgroundColor: '#fff'
        }
      }}
    >
      <Stack sx={{ p: 2.5, gap: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center" gap={1}>
            <Box
              component="span"
              sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#3D3D3D',
                color: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
              }}
            >
              <Box component="i" className="fa-light fa-camera" sx={{ fontSize: 12, ...SMOOTH_ICON_SX }} />
            </Box>
            <Typography sx={{ fontSize: 14, fontWeight: 500, color: '#464646' }}>
              {t('supervision.hardware.detail.photos')}
            </Typography>
          </Stack>
          <IconButton
            onClick={onClose}
            size="small"
            aria-label={t('actions.close')}
            sx={{ color: '#656565', width: 28, height: 28 }}
          >
            <Box component="i" className="fa-light fa-xmark" sx={{ fontSize: 14, ...SMOOTH_ICON_SX }} />
          </IconButton>
        </Stack>

        <Carousel
          data={data?.pictures ?? []}
          loading={loading}
          initialIndex={initialIndex}
          itemLabel={t('supervision.hardware.detail.photos')}
          emptyLabel={t('supervision.hardware.detail.no_photos', 'Aucune photo disponible')}
          autoFocus
        />
      </Stack>
    </Dialog>
  )
}

export default Pictures
